import { DestroyRef, Injectable, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { RealtimeHubService } from '../../core/hubs/realtime/realtime-hub.service';

@Injectable({ providedIn: 'root' })
export class PendingRequestsBadgeService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly realtimeHub = inject(RealtimeHubService);

  /** Pending approval count shown in the sidebar (Super Admin). */
  readonly count = signal<number>(0);

  constructor() {
    this.realtimeHub
      .on$('DashboardCountsUpdates')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((payload) => {
        const role = String(payload.role ?? '').trim().toLowerCase();
        if (role !== 'superadmin') return;

        const counts = payload.superAdminCounts;
        if (!counts || typeof counts !== 'object') return;

        const pending = counts.pendingApprovals;
        // Partial hub payloads omit unchanged fields; do not zero the badge (same as dashboard cards).
        if (pending === null || pending === undefined) return;

        this.setCount(pending);
      });
  }

  setCount(value: number | null | undefined): void {
    const n =
      typeof value === 'number' && Number.isFinite(value) ? Math.max(0, Math.trunc(value)) : 0;
    this.count.set(n);
  }
}
